// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2OCYy","content":"styles_content__2E8-a","intro":"styles_intro__3QBn5"};